module.exports = __webpack_public_path__ + "static/media/aboutUs_credo.4f60ea0a.svg";